<template>
<div class="ware">
     <div class="ware_view">

    </div>
    <div class="message">
        <message></message>
  </div>
</div>
</template>

<script>
import message from './message.vue';
export default {
  name: 'warelives',
  components:{
    message
  },
  props: {
    
  },
  data() {
    return {
      showUntils:true,
      msglist:[
        {   
            headerimg:'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fc-ssl.duitang.com%2Fuploads%2Fblog%2F202107%2F09%2F20210709142454_dc8dc.thumb.1000_0.jpeg&refer=http%3A%2F%2Fc-ssl.duitang.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1663314082&t=d2b7d374e4afd47253a1ca2834070f1a',
            name:'张三疯',
            type:'1',
            text:'你是在做什么你是在做什么你是在做什么你是在做什么你是在做什么你是在做什么你是在做什么'
        }
      ]
    }
  },
  created() {
    console.log(this.facelist);
  },
  methods: {
    showUntil(){
        this.showUntils = this.showUntils == true?false:true
    },
    clickcommodity(){
        this.$emit("clickcommodity",true)
    },
    clickcustomer(){
        this.$emit("clickcustomer",true)
    },
    clickreward(){
        this.$emit("clickreward",true)
    },
    clickrecommend(){
        this.$emit("clickrecommend",true)
    },
    clickprivatesms(){
        this.$emit("clickprivatesms",true)
    },
  },
 
}
</script>
<style scoped>
.ware{
    width: 100%;
    height: 100%;
}
.ware_view{
    width: 100%;
    height: 31%;
    margin-bottom: 1%;
    background-color: #04BAF3;
    border-radius: 10px;
}
.message{
    position: relative;
    width: 100%;
    height: 68%;
    background: #FAFAFA;
    border-radius: 10px;
}
.title_msg{
    padding-top: 18px;
    height: 42px;
    font-size: 16px;
    color: #256EE7;
    font-weight: 550;
    box-shadow: 0px 2px 8px 0px rgba(0,0,0,0.1);
}
.line_title{
    width: 32px;
    height: 3px;
    margin: 4px auto;
    background-color: #256EE7;
    border-radius: 2px;
}
.message_view{
    padding-bottom: 10px;
    height: 70%;
    width: 100%;
    overflow-y: scroll;
    border-color: #EEEEEE;
}
.message_view::-webkit-scrollbar {
  width: 0px;
}
.message_item{
    margin: 0 auto;
    margin-top: 24px;
    width: 80%;
    text-align: left;
}
.test1{
    word-break: break-all;
}
.message_item img{
    width: 30px;
    height: 30px;
    border-radius: 50%;
    vertical-align: top;
}
.message_item span{
    font-size: 12px;
    margin-left: 8px;
    color: #999999;
}
.input_until{
    position: absolute;
    bottom: 3%;
    width: 100%;
    height: 14%;
    box-shadow: 0px -2px 8px 0px rgba(0,0,0,0.1);
    border-radius: 0px 0px 10px 10px;
} 
.input_until>div{
    height: 40px;
    line-height: 40px;
    text-align: left;
    /* background: #FFFFFF; */
}
.props_msg{
    display: inline-block;
    margin-left: 37px;
    /* width: 65%; */
    font-size: 13px;
    padding: 12px 16px;
    background: #FFFFFF;
    box-shadow: 0px 4px 16px 0px rgba(0,0,0,0.1);
    border-radius: 0px 5px 5px 5px;
}
.input_until>div:first-child{
    background: #FFFFFF;
}
.input_until>div:first-child img{
    float: left;
    height: 24px;
    width: 24px;
    margin-left: 16px;
    margin-top: 8px;
}
.until_box{
    float: right;
    margin-right: 20px;
}
.input_message{
    height: 36px;
    margin-left: 4px;
}
.input_message>div:first-child input{
    padding-left: 16px;
    width: 81%;
    height: 36px;
    line-height: 36px;
    background: #EEEEEE;
    border-radius: 10px 0px 0px 10px;
    border: 0;
    outline: none;
    font-size: 14px;
    float: left;
}
.input_message>div:nth-child(2){
    float: left;
    width: 13%;
    height: 36px;
    background: linear-gradient(153deg, #04BAF3 0%, #256EE7 96%);
    border-radius: 0px 10px 10px 0px;
    font-size: 14px;
    text-align: center;
    color: #FFFFFF;
}
.col_until{
    position: absolute;
    bottom: 72px;
    right: 14px;
    width: 36px;
    /* height: 208px; */
}
.col_until img{
    width: 36px;
    height: 36px;
    margin-bottom: 16px;
}
.user_label{
    display: inline-block;
    margin-left: 10px;
    color: #FFFFFF;
    font-size: 10px;
    width: 32px;
    height: 18px;
    text-align: center;
    line-height: 18px;
    background: linear-gradient(314deg, #377FF7 0%, #44B0FF 100%);
    border-radius: 2px 2px 2px 2px;
}
.hands_state{
    position: absolute;
    bottom: 105px;
    right: 78px;
}
.hands_state>div{
    color: #FFFFFF;
    width: 87px;
    height: 36px;
    background: url(../../assets/lives/jushouing.png);
    background-size: 100%;
    text-align: left;
    padding-left: 5px;
    line-height: 18px;
}
.hands_state>div>div:first-child{
    width: 56px;
    text-align: center;
    font-size: 12px;
}
.hands_state>div>div:nth-child(2){
     width: 56px;
    text-align: center;
    font-size: 10px;
}
</style>
